// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DraggableUsers_wrapper_86_Wf","bigWrapper":"DraggableUsers_bigWrapper_15Poo","button":"DraggableUsers_button_2ZyyJ"};